export default __webpack_public_path__ + "static/media/star-empty.035085c9.svg";